import type { UseActionResult, UseMutationProps } from '@ztechapps/common.hook'
import { useActionMutation } from '@ztechapps/common.hook'
import { gql } from '@apollo/client'
import { projectDocumentFragment } from './graphql'
import type { MoveProjectTasksArgs, Project } from '@ztechapps/common.contract'

export const moveProjectTasksQuery = gql`
  mutation moveProjectTasks($input: MoveProjectTasksArgs!) {
    moveProjectTasks(input: $input) {
      ...projectDocumentFragment
    }
  }
  ${projectDocumentFragment}
`

export const useMoveProjectTasks = (
  { query, ...props } = {} as UseMutationProps
): UseActionResult<Project, MoveProjectTasksArgs> => {
  query = query ?? moveProjectTasksQuery

  return useActionMutation({
    query,
    ...props,
  })
}
